// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__QndVQ","question":"Question_question__1uBVB","description":"Question_description__XVTnK"};